/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsOsvVulnerabilityVersionDetail {
    getFixupPrototypeFunction() { return AppSecopsOsvVulnerabilityVersionDetail.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsOsvVulnerabilityVersionDetail>): AppSecopsOsvVulnerabilityVersionDetail {
        let obj = Object.assign(new AppSecopsOsvVulnerabilityVersionDetail(), model);
        AppSecopsOsvVulnerabilityVersionDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsOsvVulnerabilityVersionDetail>): AppSecopsOsvVulnerabilityVersionDetail {
        if (!model) return null;
        return AppSecopsOsvVulnerabilityVersionDetail.newInstance(<AppSecopsOsvVulnerabilityVersionDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsOsvVulnerabilityVersionDetail) {
        if (!obj) return;

        models.AppSecopsOsvVulnerabilityVersionDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsOsvVulnerabilityVersionDetail): boolean {
        Object.setPrototypeOf(obj, AppSecopsOsvVulnerabilityVersionDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.events) {
            for (let val of this.events) {
                models.AppSecopsOsvVulnerabilityFixDetails.fixupPrototype(val);
            }
        }
    }

    events: Array<models.AppSecopsOsvVulnerabilityFixDetails>;

    type: string;

}
